import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type CatalogPermissionUserConfigConstructor,
  CatalogPermissionUserConfig,
} from './CatalogPermissionUserConfig'

export const CatalogPermissionUserConfigConstructorFactory =
  Factory.Sync.makeFactory<CatalogPermissionUserConfigConstructor>({
    id: Factory.each(() => faker.random.number()),
    fullName: Factory.each(() => faker.name.findName()),
    email: Factory.each(() => faker.internet.email()),
    grantedSecondaryCategoryIds: [],
  })

export const CatalogPermissionUserConfigFactory = EntityFactory(
  CatalogPermissionUserConfig,
  CatalogPermissionUserConfigConstructorFactory
)
